import { Injectable } from '@angular/core';

@Injectable()
export class BzAlertActions implements IBzAlertActions {

  static ADD = '[Bz Alert] ADD';

  public Add(alertMessages: IBzAlertMessage[]): any {
    return {
      type:  BzAlertActions.ADD,
      payload: alertMessages
    };
  }

}
